import { createPersistentCacheContext } from '@kaiizen/react-persistent-cache';

export const AUTH_SESSION_KEY = 'auth-session';
export const AUTH_RECORD_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export const {
  PersistentCacheProvider: AuthPersistenceProvider,
  usePersistentCache: useAuthPersistence,
} = createPersistentCacheContext('auth-persistence');
